import React, { Component } from "react";

import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import AutoSizeInput from "../../components/AutoSizeInput/AutoSizeInput";

class ModifyTextForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      type: null,
      titulo: null,
      info: null
    };
  }

  handleOnChange = evt => {
    this.setState({ [evt.target.name]: evt.target.value });
  };

  handleChangeTypeDropdown = label => {
    this.setState({ type: label });
  };

  handleUpdateButton = () => {
    const newEvent = {
      id: this.props.textToModify.id,
      type: this.state.type ? this.state.type : this.props.textToModify.type,
      title: this.state.titulo
        ? this.state.titulo
        : this.props.textToModify.titulo,
      info: this.state.info ? this.state.info : this.props.textToModify.info
    };

    //console.log(newEvent);
    this.props.onClickUpdateButton(newEvent);
  };

  render() {
    const classes = {
      paper: {
        width: "50%",
        margin: "5% auto",
        backgroundColor: "white",
        border: "2px solid #dcdcdc",
        boxShadow: "5px",
        padding: "20px 20px"
      },
      buttonContainer: {
        textAlign: "center"
      },
      button: {
        margin: "0 auto"
      },
      buttonClose: {
        marginLeft: "480px"
      },
      formContainer: {
        display: "grid"
      },
      image: {
        margin: "0 auto",
        width: "400px",
        height: "auto",
        padding: "15px"
      },
      imageUploader: {
        margin: "0 auto",
        textAlign: "center"
      }
    };

    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.props.show}
          onClose={this.props.onClose}
        >
          <div style={classes.paper}>
            <div style={classes.formContainer}>
              <AutoSizeInput
                onChange={this.handleOnChange}
                rows={1}
                label="Título"
                name="titulo"
                defaultValue={this.props.textToModify.title}
              />
              <AutoSizeInput
                onChange={this.handleOnChange}
                name="info"
                rows={4}
                label="Días"
                defaultValue={this.props.textToModify.info}
              />
              <Button
                style={classes.button}
                variant="contained"
                color="primary"
                onClick={() => this.handleUpdateButton()}
              >
                Actualizar Texto
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ModifyTextForm;
